<template>
    <div class="page-container">
        <div style="flex: 1; min-width: 80%">
            <Transition name="fade">
                <el-form
                    v-if="formVisible"
                    :inline="true"
                    class="search-form"
                    :model="queryForms"
                    label-position="top"
                    style="padding: 0 20px"
                >
                    <el-form-item label="编码">
                        <el-input v-model="queryForms.code" clearable placeholder="请输入编码" style="width: 200px" />
                    </el-form-item>
                    <el-form-item label="子系统">
                        <el-select v-model="queryForms.module" placeholder="请选择子系统" clearable>
                            <el-option
                                v-for="item in moduleOption"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="queryForms.name" clearable placeholder="请输入名称" style="width: 200px" />
                    </el-form-item>
                    <el-form-item label="级别">
                        <el-select v-model="queryForms.level" placeholder="请选择级别" clearable>
                            <el-option
                                v-for="item in alarmoptions"
                                :key="item.level"
                                :label="item.label"
                                :value="item.level"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                        <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </Transition>
            <el-card class="noBorder" style="flex: 1">
                <div style="display: flex; margin-bottom: 10px">
                    <el-button type="primary" :icon="Plus" @click="onAddClick()" v-permission="['event:manger:add']">
                        添加
                    </el-button>
                    <el-button @click="uploadVisible = true" :icon="Download" v-permission="['event:manger:import']">
                        导入
                    </el-button>
                    <el-button @click="handleExport" :icon="Upload" v-permission="['event:manger:export']">导出</el-button>
                    <el-button :icon="DCaret" @click="handleSort">一键排序</el-button>
                    <div class="card-header" style="margin-left: auto">
                        <div class="circle-btn">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                :content="formVisible ? '隐藏搜索' : '显示搜索'"
                                placement="top"
                            >
                                <el-button
                                    plain
                                    circle
                                    @click="formVisible = !formVisible"
                                    :icon="Search"
                                    size="small"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                                <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <el-table
                    :data="table_data"
                    border
                    style="width: 100%"
                    v-loading="tableLoading"
                    row-key="id"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                >
                    <el-table-column label="序号" width="80" type="index" />
                    <el-table-column label="子系统" prop="module_name"></el-table-column>
                    <el-table-column label="事件编码" prop="code"></el-table-column>
                    <el-table-column label="事件名称" prop="name"></el-table-column>
                    <el-table-column label="事件类型" prop="type_show"></el-table-column>
                    <el-table-column label="是否用户设置" prop="is_set">
                        <template #default="{ row }">
                            <span>{{ row.is_set ? '是' : '否' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="list_order" label="排序" width="130">
                        <template #default="{ row }">
                            <el-input-number
                                style="width: 100px"
                                type="number"
                                v-model="row.list_order"
                                :min="0"
                                :max="999999"
                                controls-position="right"
                                size="small"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column width="150" label="告警级别" prop="video_recorder">
                        <template #default="{ row }">
                            <span v-if="row.level_show" :style="{ color: row.level_show.color }">
                                {{ row.level_show.name }}
                            </span>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="200">
                        <template #default="{ row }">
                            <el-button
                                type="primary"
                                link
                                :icon="Edit"
                                size="small"
                                @click="onEditClick(row)"
                                v-permission="['event:manger:edit']"
                            >
                                修改
                            </el-button>
                            <el-button
                                type="primary"
                                link
                                :icon="Delete"
                                size="small"
                                @click="onRemoveClick(row)"
                                v-permission="['event:manger:remove']"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryForms.page"
                    :page-sizes="[10, 20, 50]"
                    :page-size="queryForms.page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-card>
        </div>
        <forms-dialog
            v-if="formDialogVisible"
            v-model="formDialogVisible"
            :isForm="isForm"
            :modelId="selectModelId"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form
            v-if="uploadVisible"
            v-model="uploadVisible"
            @updateForm="getTableData"
            menuCode="event/source"
        ></imports-form>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { DCaret, Delete, Download, Edit, Plus, Refresh, Search, Upload } from '@element-plus/icons'
import { batchEvnetManage, delEventSource, getEventSourceLists } from '@/api/eventConfig/eventManger/eventManger.js'
import { getAlarmLevelLists } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import { getModuleOptionLists } from '@/api/module.js'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'

const formVisible = ref(true)
// 重置
const resetQueryForm = () => {
    Object.keys(queryForms.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') queryForms.value[key] = ''
    })
    getTableData()
}
// 数据源
const queryForms = ref({
    type: '',
    name: '',
    level: '',
    status: '',
    ip: '',
    area: '',
    page: 1,
    page_size: 10
})
const table_data = ref([])
const tableLoading = ref(false)
const total = ref(0)

// 子系统选项列表
const moduleOption = ref()
const filterModuleCode = ref(['app_auth', 'base', 'work'])
// 获取选项数据
const getOptionData = async () => {
    const res = await getModuleOptionLists()
    moduleOption.value = res.filter((item) => {
        if (!filterModuleCode.value.includes(item.id)) {
            return item
        }
    })
}

// 级别选项列表
const alarmoptions = ref([])

// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const result = await getEventSourceLists(queryForms.value)
    const alarmRes = await getAlarmLevelLists()
    alarmoptions.value = [{ label: '事件', level: 0 }, ...alarmRes]
    result.lists.forEach((item) => {
        alarmRes.forEach((a) => {
            if (item.level === a.level) {
                item.level_show = { name: a.label, color: a.color }
            }
        })
    })
    table_data.value = result.lists
    total.value = result.total
    tableLoading.value = false
}

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    getTableData()
}
// page 页码改变触发
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 编辑
const onEditClick = (row) => {
    isForm.value = true

    selectModelId.value = row.id
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectModelId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}

// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            if (row.pid == null) {
                await delEventSource(row.id)
            } else {
            }
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

const uploadVisible = ref(false)

// 导出
const handleExport = async () => {
    ElMessageBox.confirm('您确定导出全部事件源信息吗？', {
        type: 'warning'
    })
        .then(async () => {
            console.log({ ...queryForms.value, export: 1 })
            const { data } = await getEventSourceLists({ ...queryForms.value, export: 1 })
            console.log(11111, data)
            window.open(data)
            ElMessage.success('导出成功')
        })
        .catch(() => {})
}

const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    try {
        await batchEvnetManage('batch_update_order', soreObj)
        ElMessage.success('操作成功')
    } catch (error) {}

    getTableData()
}

// 切换到前台时候执行
onMounted(() => {
    getOptionData()
    getTableData()
})
</script>

<style scoped></style>
